import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import { translate } from 'react-i18next';
import compose from 'recompose/compose';

import theme from './SkillSelectorFilter.scss';
import { MultiSelectFilter, SelectTypes } from 'common/components/core/select';

import SkillSelectors from 'common/redux/selectors/skill';
import { withRouter } from 'common/components/core/router';
import { connect } from 'react-redux';

const selectSkillName = option => option.name;
const selectSkillId = option => option.id;

class SkillFilter extends Component {
    static defaultProps = {
        getOptionLabel: selectSkillName
    };

    clearSkill = () => {
        this.props.onChange(null);
    };

    onSkillSelect = ({ values, allowEmptyOrNull }) => {
        // adding logic for multiselect and special handling for isNull case.
        const { onChange } = this.props;
        const idList = values.map(selectSkillId);
        // on clear selection
        if (!idList.length && !allowEmptyOrNull) {
            onChange();
            return;
        }
        onChange({ values: idList, allowEmptyOrNull });
    };

    render() {
        const { theme, className, skills = [], value, ...rest } = this.props;
        const disabled = !skills.length;

        const skillOptions = skills.map(skill => skill.toJS());
        return (
            <MultiSelectFilter
                {...rest}
                theme={theme}
                allowEmptyOrNull={value?.allowEmptyOrNull || false}
                disabled={disabled}
                className={className}
                selectType={SelectTypes.Outline}
                options={skillOptions}
                value={value?.values || ''}
                getOptionValue={selectSkillId}
                onChange={this.onSkillSelect}
            />
        );
    }
}

const ThemedSkillSelectorFilter = compose(
    themr('SkillFilter', theme),
    translate()
)(SkillFilter);

const ConnectedSkillSelectorFilter = withRouter(
    connect((state, ownProps) => {
        const skills = SkillSelectors.getEntities(state, ownProps);

        return {
            skills
        };
    })(ThemedSkillSelectorFilter)
);

const ConnectedSkillIdSelectorFilter = props => (
    <ConnectedSkillSelectorFilter {...props} getOptionLabel={selectSkillId} />
);

export default ThemedSkillSelectorFilter;
export { ConnectedSkillSelectorFilter, ConnectedSkillIdSelectorFilter };
